/* eslint-disable react-hooks/exhaustive-deps */
import { Tabs } from 'antd';
import * as React from 'react';
import type { TabsProps } from 'antd';
import MonitorDetail from './MonitorDetail';
import { CabinetContext } from '../../../../context/CabinetContext';
import ControlDetail from './ControlDetail';
import InfoDetail from './InfoDetail';
import Incident from '../Incident';
import Light from '../Light';
import { INodeInfo } from '..';
import LightSchedule from '../Light/Schedule';

interface IDeviceDetailModalProps {
    isShow: boolean
    handleCancel: () => void
    nodeList: INodeInfo[]
}

const DeviceDetailModal: React.FunctionComponent<IDeviceDetailModalProps> = ({ isShow, handleCancel, nodeList }) => {
    const { selectedDevice } = React.useContext(CabinetContext)!
    const [tabList, setTabList] = React.useState<TabsProps['items']>([]);
    
    const baseTabs: TabsProps['items'] = [
      {
        key: '1',
        label: 'Điều khiển',
        children: <ControlDetail />,
      },
      {
        key: '2',
        label: 'Giám sát',
        children: <MonitorDetail />,
      },
      {
        key: '3',
        label: 'Thông tin',
        children: <InfoDetail />,
      },
      {
        key: '4',
        label: 'Sự cố',
        children: <Incident />,
      },
      // {
      //   key: '5',
      //   label: 'Biểu đồ',
      //   children: 'Chart',
      // },
    ];

    React.useMemo(() => {
      const temp = [...baseTabs];
      if (nodeList.length > 0) {
        const lightTab = {
          key: '6',
          label: 'Đèn',
          children: <Light />,
        }
        temp.push(lightTab);
        const lightScheduleTab = {
          key: '7',
          label: 'Biểu đồ tiết giảm',
          children: <LightSchedule />,
        }
        temp.push(lightScheduleTab);
      }
        
      setTabList(temp);
    }, [nodeList])

    const onChange = (key: string) => {
        // console.log(key);
    };

    return (
        <>
            {/* Sliding Panel */}
            <div 
                className={`fixed top-0 right-0 h-full w-[40%] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out bg-neutral-White ${
                    isShow ? 'translate-x-0' : 'translate-x-full'
                }`}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <h2 className="text-lg font-semibold text-gray-800">
                        {selectedDevice?.name || 'Device Details'}
                    </h2>
                    <button
                        onClick={handleCancel}
                        className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
                    >
                        <svg 
                            className="w-5 h-5 text-gray-500" 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                        >
                            <path 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth={2} 
                                d="M6 18L18 6M6 6l12 12" 
                            />
                        </svg>
                    </button>
                </div>
                
                {/* Content */}
                <div className="h-full overflow-y-auto">
                    <Tabs 
                        defaultActiveKey="1" 
                        items={tabList} 
                        onChange={onChange}
                        className="px-4"
                    />
                </div>
            </div>
        </>
    );
};

export default DeviceDetailModal;
